"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DbLessonSchema = exports.LessonAttachment = exports.LessonThumbnail = exports.LessonTrail = exports.LessonCurriculaRef = exports.LessonPhaseSchema = exports.DifferentiationSchema = exports.DiffLabelSchema = exports.DiffNoPickedLabelsSchema = exports.DiffCustomEntryLabelsSchema = exports.DiffColorNumberSchema = exports.SchoolLevelSchema = exports.SchoolTypeSchema = exports.ShareOptionsSchema = exports.UserContentSchema = exports.FractionalIndexSchema = exports.UserContentOriginSchema = exports.UserContentChannelRightsSchema = exports.UserContentPrivacySchema = exports.LocationSchema = exports.LESSON_ENTITY_NAME = void 0;
const zod_1 = require("zod");
exports.LESSON_ENTITY_NAME = 'lesson';
exports.LocationSchema = zod_1.z.object({
    explorer: zod_1.z.string(),
    folder: zod_1.z.string(),
});
exports.UserContentPrivacySchema = zod_1.z.enum(['public', 'private', 'protected']);
exports.UserContentChannelRightsSchema = zod_1.z.enum(['none', 'givesProFeatures']);
exports.UserContentOriginSchema = zod_1.z.object({
    id: zod_1.z.string(),
    date: zod_1.z.date(),
    unmodified: zod_1.z.boolean().optional(),
    channel: zod_1.z.string().nullish(),
    rights: exports.UserContentChannelRightsSchema.optional(),
    rightsCheckDate: zod_1.z.date().optional(),
});
exports.FractionalIndexSchema = zod_1.z.object({});
exports.UserContentSchema = zod_1.z.object({
    creationDate: zod_1.z.string(),
    location: exports.LocationSchema.nullish(),
    user: zod_1.z.string(),
    privacy: exports.UserContentPrivacySchema.optional(),
    removed: zod_1.z.date().optional(),
    products: zod_1.z.array(zod_1.z.string()).optional(),
    channel: zod_1.z.string().nullish(),
    origin: exports.UserContentOriginSchema.optional(),
    productsLocked: zod_1.z.boolean().optional(),
    order: zod_1.z.string().nullish(),
});
exports.ShareOptionsSchema = zod_1.z.object({
    sharePublic: zod_1.z.boolean().optional(),
    shareDate: zod_1.z.date().optional(),
    publish: zod_1.z.boolean().optional(),
    publishDate: zod_1.z.date().optional(),
});
exports.SchoolTypeSchema = zod_1.z.enum(['vo', 'bso']).or(zod_1.z.string());
exports.SchoolLevelSchema = zod_1.z.enum(['m', 'h', 'v']).or(zod_1.z.string());
// https://github.com/colinhacks/zod/issues/2686
exports.DiffColorNumberSchema = zod_1.z.union([
    zod_1.z.literal(1),
    zod_1.z.literal(2),
    zod_1.z.literal(3),
    zod_1.z.literal(4),
    zod_1.z.literal(5),
    zod_1.z.literal(6),
]);
exports.DiffCustomEntryLabelsSchema = zod_1.z.enum([
    'custom-1',
    'custom-2',
    'custom-3',
    'custom-4',
    'custom-5',
    'custom-6',
]);
exports.DiffNoPickedLabelsSchema = zod_1.z.enum(['none-1', 'none-2', 'none-3', 'none-4', 'none-5', 'none-6']);
exports.DiffLabelSchema = zod_1.z.enum(['-', '+', '0']).or(exports.DiffCustomEntryLabelsSchema).or(exports.DiffNoPickedLabelsSchema);
exports.DifferentiationSchema = zod_1.z.object({
    color: exports.DiffColorNumberSchema,
    label: exports.DiffLabelSchema,
    custom: zod_1.z.string().optional(),
});
exports.LessonPhaseSchema = zod_1.z.object({
    label: zod_1.z.string(),
    subtitle: zod_1.z.string().optional(),
});
exports.LessonCurriculaRef = zod_1.z.object({
    label: zod_1.z.string(),
    objectives: zod_1.z.array(zod_1.z.string()),
});
exports.LessonTrail = zod_1.z.object({
    channel: zod_1.z.string().optional(),
    lesson: zod_1.z.string(),
    d: zod_1.z.date(),
});
exports.LessonThumbnail = zod_1.z.object({
    modifiedDate: zod_1.z.date().or(zod_1.z.string()),
    url: zod_1.z.string(),
    hash: zod_1.z.string().optional(),
    v: zod_1.z.number().optional(),
});
exports.LessonAttachment = zod_1.z.object({
    mimetype: zod_1.z.string(),
    name: zod_1.z.string(),
    type: zod_1.z.enum(['worksheet', 'instruction']),
    uploadId: zod_1.z.string(),
});
const LessonSourceSchema = zod_1.z.enum(['openAi', 'slideDeckImport']);
exports.DbLessonSchema = exports.UserContentSchema.merge(zod_1.z.object({
    _id: zod_1.z.string(),
    name: zod_1.z.string().min(1).max(300),
    country: zod_1.z.array(zod_1.z.string()),
    showPhases: zod_1.z.boolean().nullish(),
    sharing: exports.ShareOptionsSchema,
    schoolType: zod_1.z.array(exports.SchoolTypeSchema).nullish(),
    levels: zod_1.z.array(exports.SchoolLevelSchema).nullish(),
    years: zod_1.z.array(zod_1.z.number()).nullish(),
    subjects: zod_1.z.array(zod_1.z.string()).optional(),
    themes: zod_1.z.array(zod_1.z.string()).optional(),
    pinCount: zod_1.z.number(), // 3 lessons don't have this property. Will be fixed in https://lessonup.atlassian.net/browse/ED-915
    pinCountForLesson: zod_1.z.number().nullish(),
    pinCountForStudent: zod_1.z.number().nullish(),
    modifiedDate: zod_1.z.string().optional(),
    openendDate: zod_1.z.string().optional(), // Note: Misspelled in the database
    durationInMin: zod_1.z.number().nullish(),
    differentation: zod_1.z.array(exports.DifferentiationSchema).nullish(),
    sharedExplorer: zod_1.z.string().optional(),
    isTest: zod_1.z.boolean().nullish(),
    plan: zod_1.z.string().nullish(),
    phases: zod_1.z.array(exports.LessonPhaseSchema).nullish(),
    isStub: zod_1.z.boolean().optional(),
    curricula: zod_1.z.array(exports.LessonCurriculaRef).optional(),
    description: zod_1.z.string().nullish(),
    information: zod_1.z.string().nullish(),
    trail: zod_1.z.array(exports.LessonTrail).optional(),
    stats: zod_1.z.object({}).optional(),
    thumbnail: exports.LessonThumbnail.nullish(),
    attachments: zod_1.z.array(exports.LessonAttachment).nullish(),
    tags: zod_1.z.array(zod_1.z.string()).optional(),
    // TODO: templatePins
    cover: zod_1.z.string().optional(),
    header: zod_1.z.enum(['lessonup', 'coverbar']).optional(),
    coverFocusY: zod_1.z.number().optional(),
    template: zod_1.z.boolean().optional(),
    version: zod_1.z.enum(['v2']).optional(),
    source: LessonSourceSchema.optional(),
    region: zod_1.z.array(zod_1.z.string()).optional(),
    oldPrivacy: exports.UserContentPrivacySchema.optional(), // Added as part of ED-1360. TODO Remove after all goes well
}));
//# sourceMappingURL=db-lesson.js.map